<template>
    <!-- Модальное окно Сообщения о банкротстве -->
    <div id="bankrupt-tile" v-if="auth">
        <span class="bankrupt__message" @click="openModal()" v-if="isBankrupt">
			Сообщения о банкротстве
		</span>
        <modal v-if="modal_show" :close="() => { modal_show = false }" :printButton="true">
            <div slot="modalHeader" >
                <h3>
                    <i id="gavel__icon" class="uk-icon-gavel"></i> 
                    Сообщения о банкротстве
                </h3>
            </div>

            <div slot="modalBody" id="modal-company-bankrupt" style="padding: 10px">
                <pagination v-if="paginationModal && messages.length" :pagination="paginationModal" :onTurnPageCallBack="getData" :showRowsPerPageSelection="false" :rows_on_page="messages.length"/>
                <div>
                    <div v-if="messages.length">
                        <div v-for="(e,i) in messages" :key="i">
                            <p @click="showDescription(i, $event)" :id="'bankrupt-event-id'+ i" :class="'hide-bankrupt-texts' + (e.text || e.annul_text) ? '' : ' load-bankrupt-texts'" :data-id="i">
                                <span class="date bold__date">
                                    {{e.annul == 1 ? dateFormat(e.date_annul) : dateFormat(e.date_publish)}}
                                </span>
                                <span v-bind:class="'name' + ( stopFactors.indexOf(e.type_event) != -1 ? ' red' : '')">
                                    {{e.event_text + (e.annul == 1 ? ' (аннулировано)' : '')}}
                                </span>
                                <span ref="down"  class="status_hide no_print">
                                    Развернуть 
                                    <i  class="uk-icon-chevron-down"></i>
                                </span>
                                <span ref="up" class="status_hide no_print" style="display:none;">
                                    Свернуть 
                                    <i class="uk-icon-chevron-up"></i> 
                                </span>
                            </p>
                            <pre v-if="e.annul == 1 || e.annul_text" :id="'bankrupt-texts-id' + i" ref="description" class="bankrupt-texts no_print-pre" style="display:none">
                                {{e.annul_text}}
                            </pre>
                            <pre v-else-if="!e.annul == 1 || e.text" :id="'bankrupt-texts-id' + i" ref="description" class="bankrupt-texts no_print-pre" style="display:none">
                                {{e.text}}
                            </pre>
                            <pre v-else :id="'bankrupt-texts-id' + i" ref="description" class="bankrupt-texts no_print-pre" style="display:none">
                                <shestirenkaLoader  v-if="loading" />
                            </pre>
                        </div>
                    </div>
                    <div v-else-if="loading">
                        <shestirenkaLoader  v-if="loading" />
                    </div>
                    <div v-else-if="!messages.length && empty">
                        <i class="uk-icon-check" style="color: #bcf2db; font-size: 30px;"></i>
                        <span style="margin-top: 10px; color: #777;">Сообщения о банкротстве не найдены.</span>
                    </div>
                    <div v-else-if="error">
                        <i class="uk-icon-exclamation-triangle" style="color: #999; font-size: 30px;"></i>
                        <span style="margin-top: 10px; color: #777;">Не удалось загрузить сообщения о банкротстве.<br>Попробуйте повторить запрос позже или обратитесь в службу технической поддержки.</span>
                    </div>

                </div>
                <pagination v-if="paginationModal && messages.length" :pagination="paginationModal" :onTurnPageCallBack="getData" :showRowsPerPageSelection="false" :rows_on_page="messages.length"/>
            </div>
        </modal>
    </div>
</template>

<script>
import modal from '@/components/ui/modal.vue'
import pagination from '@/components/ui/pagination.vue'
import shestirenkaLoader from '@/components/ui/shestirenkaLoader.vue'


export default {
    components:{ modal, pagination, shestirenkaLoader },
    data(){
        return{
            modal_show: false,
            isBankrupt: false,
            messages: [],
            stopFactors: [1,2,3,4,5],
            paginationModal: {},
            loading: false,
            empty: false,
            error: false
        }
    },
    mounted() {
        if(this.auth && this.window.company?.inn) {
            this.getStatus()
        }
    },
    methods:{
        getStatus(){
            this.$store.dispatch("RomAPI", {
                method: "bankrupt",
                data: {
                    action: "status",
                    inn: window.company.inn
                },
            }).then(e => {
                if(e.data.code == 0 && e.data.data.status == 1) {
                    this.isBankrupt = true
                }
            })
        },
        getData(offset = 0, limit = 15) {
            this.loading = true
            this.$store.dispatch("RomAPI", {
                method: "bankrupt",
                data: {
                    action: "list_event",
                    inn: window.company.inn,
                    offset,
                    limit
                },
            }).then(e => {
                if(e.data.data && e.data.data.list && e.data.data.list.length) {
                    this.messages = e.data.data.list
                    this.paginationModal = e.data.data.pagination
                }
                else {
                    this.empty = true
                }
            }).finally(() => {
                this.loading = false
            }).catch(msg => {
                console.log(msg)
                this.error = true
            })
        },
        openModal(){
            this.getData();
            this.modal_show = true
        },
        showDescription(i, evt){
            if(this.$refs.description[i].style.display != "none") {
                this.$refs.up[i].style.display = "none"
                this.$refs.down[i].style.display = "inline"
                this.$refs.description[i].style.display = "none"
            }
            else {
                this.$refs.down[i].style.display = "none"
                this.$refs.up[i].style.display = "inline"
                this.$refs.description[i].style.display = "block"
            }
        },
        dateFormat(date) {
            var dt = new Date(date)

            if(!dt.valueOf()) {
                return date;
            } 

            var strDate = '0' + dt.getDate()
            var strMonth = '0' + (dt.getMonth() * 1 + 1)
            var strYear = dt.getFullYear()

            return strDate.slice(-2) + "." + strMonth.slice(-2) + "." + strYear
        }
    },
    computed: {
        auth(){
            return window.auth
        }
    }
}
</script>

<style lang="sass" scoped>
.bankrupt__message
    cursor: pointer
    color: rgb(231, 76, 60)
    border-bottom: dashed 1px rgba(231, 76, 60, 0.2)
    font-size: 13px !important
    display: inline

#gavel__icon
    position: relative
    top: 0
    cursor: none
    color: #444444
    opacity: 1.0
pre 
    white-space: pre-line 
#modal-company-bankrupt 
    .date 
        margin-right: 10px
        font-weight: 600
    .hide-bankrupt-texts 
        cursor: pointer
    p:hover 
        color: #074c92 !important
        cursor: pointer 

#modal-company-bankrupt 
    .hide-bankrupt-texts
        &:hover >
            .status_hide
                color: #6d6c6c
    .hide-bankrupt-texts
        &:hover > 
            .status_show
                color: #6d6c6c

.status_hide
    font-size: 11px !important
    color: #a0a0a0

.status_show
    font-size: 11px !important
    color: #a0a0a0

#bankrupt-modal-button-update,
#bankrupt-modal-button-show_all, 
#bankrupt-modal-button-hide_all
    float: left
    margin-left: 5px


#bankrupt-modal-updated
    float: left
    color: #28a85e
    font-weight: 600
    display: none

#bankrupt-modal-pagination 
    float: left
span
    font-size: 16px !important

h3    
    font-family: Arial,Tahoma,sans-serif
    font-weight: 100
    font-size: 24px !important
    border-bottom: none !important
</style>